import { createFrontendModule } from '@backstage/frontend-plugin-api';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { ScaffolderPage } from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  ScaffolderFieldExtensions,
} from '@backstage/plugin-scaffolder-react';
import { CustomTaskPage } from '../components/CustomTaskPage';
import { OktaEmailField } from '../components/OktaEmailField';

export const OktaEmailFieldExtension = createScaffolderFieldExtension({
  name: 'OktaEmailField',
  component: OktaEmailField,
}).expose();

export const scaffolderOverrideModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    scaffolderPlugin.getExtension('page:scaffolder').override({
      params: {
        loader: async () => (
          <ScaffolderPage
            headerOptions={{ title: 'Launch a Sandbox' }}
            components={{ TaskPageComponent: CustomTaskPage }}
            contextMenu={{
              tasks: false,
              actions: false,
              editor: false,
              templatingExtensions: false,
            }}
          >
            <ScaffolderFieldExtensions>
              <OktaEmailFieldExtension />
            </ScaffolderFieldExtensions>
          </ScaffolderPage>
        ),
      },
    }),
  ],
});
